import { render, staticRenderFns } from "./nasional.vue?vue&type=template&id=9a1a1e50&"
import script from "./nasional.vue?vue&type=script&lang=js&"
export * from "./nasional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports